export function GapSection() {
  return (
    <section className="landing-section landing-gap">
      <div className="landing-section-inner">
        <h2 className="landing-section-title">Most calculators tell you a number. They don't tell you what happens next.</h2>
        <div className="landing-gap-content">
          <p>
            You need to know how your SIPP, ISA, and State Pension work together — which
            account to draw from first, how tax changes year by year, and whether your money
            lasts if markets fall early.
          </p>
          <p>
            Glide-Path models all of this — with withdrawal strategies, what-if scenarios,
            and UK tax rules built in.
          </p>
          <p>
            <strong>See whether your money could last — and explore what different choices
            might mean.</strong>
          </p>
        </div>
      </div>
    </section>
  );
}
